export const allowedVideoTypes: string[] = [
  'video/mp4',
  'video/mov',
  'video/avi',
  'video/wmv',
  'video/webm'
]

export const allowedImageTypes: string[] = [
  'image/png',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/webp'
]

export const customeDownloadTypes: string[] = [
  'png',
  'gif',
  'jpeg',
  'jpg',
  'webp'
]

export const allowedImageAndVideoTypes: string[] = [
  'image/png',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'video/mp4',
  'video/webm'
]

export const MAX_VIDEO_SIZE = 600 * 1024 * 1024

/** Primary raster slots: `image`, `activeImage`, `largeImage`, landing-page file, variant previews (~8MB). */
export const MAX_ASSET_PRIMARY_RASTER_BYTES = 8 * 1024 * 1024

/** Hotpoints desktop / mobile raster uploads (~4MB). */
export const MAX_ASSET_HOTPOINTS_RASTER_BYTES = 4 * 1024 * 1024

/** @deprecated Use {@link MAX_ASSET_PRIMARY_RASTER_BYTES} */
export const MAX_LANDING_PAGE_ASSET_IMAGE_SIZE = MAX_ASSET_PRIMARY_RASTER_BYTES

export const isLandingPageAssetImageSizeAllowed = (file: File) =>
  file.size <= MAX_ASSET_PRIMARY_RASTER_BYTES

export const isVideoSizeAllowed = (file: File) => {
  return file.size <= MAX_VIDEO_SIZE
}

export const isVideoTypeAllowed = (file: File) => {
  return allowedVideoTypes.includes(file.type)
}
